import * as React from "react";
const SvgFiRrCircleV = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-circle-v_svg__a)">
      <path
        fill="#062147"
        d="m17.727 8.114-3.22 8.769a2.645 2.645 0 0 1-2.469 1.637c-1.086 0-2.048-.628-2.453-1.596L6.35 8.114a.999.999 0 1 1 1.877-.69l3.22 8.77c.126.3.485.326.592.326s.465-.026.607-.367l3.204-8.728a1 1 0 1 1 1.877.689m6.312 3.904c0 6.618-5.383 12-12 12s-12-5.381-12-11.998 5.383-12 12-12 12 5.383 12 12zm-2 0c0-5.513-4.486-10-10-10s-10 4.488-10 10.002 4.486 10 10 10 10-4.486 10-10z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-circle-v_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCircleV;
